import { COLOR_PALETTE } from 'constants/ui';

export const voicemailContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const headerRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const headerTitleStyles = {
  fontWeight: 600,
  color: ({ palette }) => palette.text.strong,
};

export const markAllReadButtonStyles = {
  fontSize: '12px',
  textTransform: 'none',
  padding: '2px 8px',
  minWidth: 'auto',
};

export const listContainerStyles = {
  flex: 1,
  overflow: 'auto',
};

export const voicemailRowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 16px',
  cursor: 'pointer',
  transition: 'background-color 0.15s',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const voicemailRowUnreadStyles = {
  ...voicemailRowStyles,
  backgroundColor: COLOR_PALETTE.BRAND[1],
  '&:hover': {
    backgroundColor: COLOR_PALETTE.BRAND[2],
  },
};

export const unreadDotStyles = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.BRAND[6],
  flexShrink: 0,
  marginTop: '6px',
};

export const readDotPlaceholderStyles = {
  width: 8,
  height: 8,
  flexShrink: 0,
  marginTop: '6px',
};

export const voicemailInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  flex: 1,
  gap: '2px',
};

export const callerNameStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: ({ palette }) => palette.text.strong,
  fontWeight: 600,
};

export const callerNameReadStyles = {
  ...callerNameStyles,
  fontWeight: 400,
};

export const voicemailDetailStyles = {
  color: ({ palette }) => palette.text.placeholder,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const durationIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

export const voicemailTimeStyles = {
  flexShrink: 0,
  textAlign: 'right',
  color: ({ palette }) => palette.text.placeholder,
};

export const playerRowStyles = {
  padding: '0 16px 8px 36px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const actionsRowStyles = {
  display: 'flex',
  gap: '4px',
  padding: '4px 0 0',
};

export const actionButtonStyles = {
  minWidth: 'auto',
  padding: '4px 8px',
  fontSize: '11px',
  textTransform: 'none',
};

export const deleteButtonStyles = {
  ...actionButtonStyles,
  color: COLOR_PALETTE.RED[6],
};

export const emptyStateStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  padding: '24px',
  gap: '8px',
};

export const emptyStateIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

export const emptyStateTextStyles = {
  textAlign: 'center',
  color: ({ palette }) => palette.text.placeholder,
};

export const loadingContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
};
